export default function DistanciersConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('distanciers');
}

DistanciersConfiguration.$inject = ['$translatePartialLoaderProvider'];
